export default __webpack_public_path__ + "static/media/24-hours-active.acc7fe26.svg";